import { gql } from '@apollo/client';

export const ALL_CASH_LIMITS_QUERY_NAME = 'AllCashLimits';
export const ALL_CASH_LIMITS = gql`
    query ${ALL_CASH_LIMITS_QUERY_NAME}(
        $page: Int, 
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
        $valueMapping: Map_String_List_MappedValueScalar,
    ) {
        allCashLimits(
            page: $page, 
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
            valueMapping: $valueMapping,
        ) {
            availableUploadClearingHouses {
                code
                name
                uploadBlockers
            }
            cashLimitList {
                totalCount
                models {
                    id
                    mainId
                    limitValue
                    beginDate
                    endDate
                    creator
                    status
                    version
                    token
                    definitionDescription
                    customName
                    ccp
                    tso
                    clearingMember
                    member {
                        name
                        memberId
                    }
                }
            }
        }
    }
`;

export const ON_CASH_LIMIT_CHANGED = gql`
    subscription onCashLimitChanged {
        cashLimitChanged {
            correlationId
            action
            model {
                totalCount
                models {
                    id
                }
            }
        }
    }
`;
